import React, { useState } from 'react'
import Menu from '@material-ui/core/Menu'
import MenuItemComponent from './MenuItemComponent'
import useMenuListStyles from './useMenuListStyles'
import LoadingComponent from './LoadingComponent'
import ButtonComponent from '../../common/button/Button.component'
import PropTypes from 'prop-types'
import * as _ from 'lodash'
import { MenuItemSelectorComponent } from './MenuItemSelectorComponent'
import { BOX_SHADOW_PAPER } from 'cfgCommon/mixins'
import CustomDatePicker from 'common/CustomDatePicker'

const MenuComponent = props => {
    const {
        anchorEl,
        handleClose,
        options = [],
        title,
        subTitle,
        titleVariant,
        multiSelect,
        twoLines,
        isLoading,
        rightText,
        descriptionText,
        selectedValues,
        handleOptionClick = () => undefined,
        id,
        buttons,
        sizeButtons,
        labelPrimaryButton,
        onClickPrimaryButton,
        labelSecondaryButton,
        onClickSecondaryButton,
        typeSecondaryButton,
        menuMaxHeight,
        closeOnSelect,
        labelNotMatch = "No hay coincidencias",
        menuWidth,
        ...otherProps
    } = props

    const classes = useMenuListStyles()
    // state que solo se utiliza cuando el menu es llamado sin dropdown
    const [selectedValuesMenu, setSelectedValuesMenu] = useState([])

    let handleOptionClickMenu;
    // si el menu es llamado sin dropdown, se utiliza handleOptionClickMenu
    if(!id){
        handleOptionClickMenu = ({ value, label: optionLabel }) => {
            // Si la prop multiSelect es true, se van agregando los nuevos objetos al array de valores seleccionados
            // De lo contrario, se establece un array con un solo objeto, que se va reemplazando a medida que se
            // seleccionan diferentes valores.
            if (multiSelect) {
                setSelectedValuesMenu(prevState => {
                    let newSelectedValues = [...selectedValuesMenu, { value, label: optionLabel }]
                    newSelectedValues = _.uniqBy(newSelectedValues, 'value')
                    if (_.isEqual(prevState, newSelectedValues)) {
                        newSelectedValues = newSelectedValues.filter(
                            elem => elem.value !== value
                        )
                    }
                    return newSelectedValues
                })
            } else {
                setSelectedValuesMenu(prevState => {
                    if (_.isEqual(...prevState, { value, label: optionLabel })) {
                        return []
                    }
                    return [{ value, label: optionLabel }]
                })
            }
        }

    }

    const titleMenu = title && title !== '' && (
        <MenuItemComponent
            label={title}
            descriptionText={subTitle}
            titleVariant={titleVariant}
        />
    )

    const safeOptions = Array.isArray(options) ? options : []
    const drawOptions = safeOptions.map((opt, index) => {

        if (opt.title) return <MenuItemComponent
            label={opt.title}
            descriptionText={opt.titleDescription}
            titleVariant={opt.titleVariant || titleVariant}
        />

        if (opt.type === 'selector') return <MenuItemSelectorComponent
            {...opt}
            value={opt?.defaultValue}
            selectedValues={selectedValues}
            handleOptionClick={handleOptionClick}
            isDisabled={opt?.enabledWith ? !(selectedValues.find(f=>f?.selectorId===opt?.enabledWith)) : opt?.isDisabled}
        />

        if (opt.name === 'Fecha personalizada'){
            return (
                <CustomDatePicker
                    onApply={(data)=>{
                        handleOptionClick(data)
                        handleClose()
                    }}
                    fromReceived={opt.from}
                    toReceived={opt.to}
                />
            )
        }
        return <MenuItemComponent
            key={index}
            onClick={!id
                ? () => handleOptionClickMenu({ value: opt.value, label: opt.label })
                : () => {
                    handleOptionClick({ value: opt.value, label: opt.label })
                    closeOnSelect && handleClose()
                }}
            label={opt.label}
            multiSelect={multiSelect}
            twoLines={twoLines}
            disabled={opt.disabled || false}
            descriptionText={descriptionText && (opt.descriptionText || descriptionText)}
            rightText={rightText && (opt.rightText || rightText)}
            selected={!id ? selectedValuesMenu?.some(elem => elem.value === opt.value) : selectedValues?.some(elem => elem?.value === opt.value)}
        />}
    )

    const drawNoOptionsAvailable = !options.length && <MenuItemComponent label={labelNotMatch} disabled/>

    MenuComponent.propTypes = {
        isLoading: PropTypes.bool,
        descriptionText: PropTypes.string,
        title: PropTypes.string,
        multiSelect: PropTypes.bool,
        twoLines: PropTypes.bool,
        rightText: PropTypes.string,
        buttons: PropTypes.oneOf(['one button', 'two buttons']),
        sizeButtons: PropTypes.oneOf(['small', 'medium']),
        labelPrimaryButton: PropTypes.string,
        onClickPrimaryButton: PropTypes.func,
        labelSecondaryButton: PropTypes.string,
        onClickSecondaryButton: PropTypes.func,
        typeSecondaryButton: PropTypes.oneOf(['secondary', 'tertiary']),
        menuMaxHeight: PropTypes.string,
    }
    return (
        <Menu
            autoFocus={false}
            className={classes.root}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            disableEnforceFocus
            PaperProps={{
                style: {
                    minWidth: menuWidth ? null : anchorEl?.offsetWidth,
                    maxWidth: menuWidth ? null : '100%',
                    boxShadow: BOX_SHADOW_PAPER,
                    width: menuWidth || 'fit-content',
                    maxHeight: menuMaxHeight,
                    marginTop: '8px',
                },
            }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
            }}
            {...otherProps}
        >
            {isLoading ? <LoadingComponent /> : [titleMenu, ...drawOptions, drawNoOptionsAvailable]}
            {buttons && Boolean(anchorEl) &&
                <div className={classes.containerButtons}>
                    {buttons === 'two buttons' &&
                    <span>
                        <ButtonComponent
                            theme='light'
                            type={typeSecondaryButton}
                            size={sizeButtons}
                            label={labelSecondaryButton}
                            disabled={false}
                            onClick={onClickSecondaryButton}
                        />
                    </span>
                    }
                    <span style={{marginLeft: '1rem', marginRight: anchorEl?.offsetWidth > 250 ? '1rem' : '0'}}>
                        <ButtonComponent
                            theme='light'
                            type='primary'
                            size={sizeButtons}
                            label={labelPrimaryButton}
                            disabled={false}
                            onClick={onClickPrimaryButton}
                        />
                    </span>
                </div>
            }
        </Menu>
    )
}

export default MenuComponent
